<template>
  <div style="display: contents">
    <slot name="back-to-top" :is-visible="isVisible"></slot>
  </div>
</template>

<script>
import { ScrollBehavior } from './mixins/constants';

export default {
  name: 'refapp-back-to-top',
  props: {
    visibilityThreshold: {
      type: Number,
      validator(value) {
        return value > 0;
      },
      default: 2,
    },
    scrollBehavior: {
      type: String,
      validator(value) {
        return Object.values(ScrollBehavior).includes(value);
      },
      default: ScrollBehavior.Auto,
    },
  },
  data() {
    return {
      isVisible: false,
    };
  },
  mounted() {
    document.documentElement.classList.add(`ra-back-to-top--${this.scrollBehavior}`);
    document.body.classList.add(`ra-back-to-top--${this.scrollBehavior}`);
    window.addEventListener('scroll', this.handleScroll);
  },
  beforeDestroy() {
    document.documentElement.classList.remove(`ra-back-to-top--${this.scrollBehavior}`);
    document.body.classList.remove(`ra-back-to-top--${this.scrollBehavior}`);
    window.removeEventListener('scroll', this.handleScroll);
  },
  methods: {
    handleScroll() {
      const scrollPosition = window.scrollY || document.documentElement.scrollTop;
      const screenHeight = window.innerHeight;
      this.isVisible = scrollPosition > this.visibilityThreshold * screenHeight;
    },
  },
};
</script>

<style lang="scss" src="../styles/style.scss"></style>
